import React from 'react';
import TheHoleLanding from './TheHoleLanding';

function App() {
  return <TheHoleLanding />;
}

export default App;
